
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from "@kontent-ai/delivery-sdk";
import type { CoreContentType } from "../system/index.js";
import type { Icons, Products, Roles } from "../taxonomies/index.js";
import type { NavInternalLink, NavExternalLink } from "./index.js";

/**
 * 🔗 Nav // Menu Item
 *
 * Id: 947c785c-6f08-4704-aa56-2c12c5bdd911
 * Codename: menu_item
 */
export type NavMenuItem = CoreContentType<
  NavMenuItemElementCodenames,
  {
    /**
     * Icons
     *
     * Type: taxonomy
     * Required: true
     * Codename: icon
     * Id: e3e76ccb-3420-4da2-8645-8c4292640f5c
     */
    readonly icon: Elements.TaxonomyElement<Icons, "icon">;
    /**
     * Link
     *
     * Type: modular_content
     * Required: true
     * Codename: link
     * Id: 535912c8-e424-41ab-8424-43580e5e5cdd
     */
    readonly link: Elements.LinkedItemsElement<
      NavInternalLink | NavExternalLink
    >;
    /**
     * Products
     *
     * Type: taxonomy
     * Required: false
     * Codename: products
     * Id: 94116b64-4c5f-4673-bcca-84a9a1884911
     * Guidelines: • Restrict the visibility of this content to selected products. • If no products are selected, the content will be visible to all users.
     */
    readonly products: Elements.TaxonomyElement<Products, "products">;
    /**
     * Roles
     *
     * Type: taxonomy
     * Required: false
     * Codename: roles
     * Id: e77624f6-a718-4a62-adb9-55aa5276623c
     * Guidelines: • Restrict the visibility of this content to users with selected roles. • If no roles are selected, the content will be visible to all users.
     */
    readonly roles: Elements.TaxonomyElement<Roles, "roles">;
  },
  "menu_item"
>;

/**
 * Type representing all available element codenames for 🔗 Nav // Menu Item
 */
export type NavMenuItemElementCodenames =
  | "icon"
  | "link"
  | "products"
  | "roles";

/**
 * Type guard for 🔗 Nav // Menu Item
 *
 * Id: 947c785c-6f08-4704-aa56-2c12c5bdd911
 * Codename: menu_item
 */
export function isNavMenuItem(item: CoreContentType | undefined | null): item is NavMenuItem {
    return item?.system?.type === 'menu_item';
}
